import type { TipsterDetailDto } from '@/api/backoffice-schemas';

export function getTipsterDisplayName(
  tipster: TipsterDetailDto | undefined
): string {
  if (!tipster?.userName) {
    return 'Anonymous';
  }
  return tipster.userName;
}

export function getTipsterCorrectPercentage(
  tipster: TipsterDetailDto
): string | undefined {
  const { correct, wrong } = tipster;

  if (correct == null || wrong == null || correct < 0 || wrong < 0) {
    return;
  }

  const total = correct + wrong;

  // Can't calculate percentage if no predictions exist
  if (total === 0) {
    return;
  }

  const percentage = (correct / total) * 100;
  return percentage.toFixed(0);
}
